import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, inject, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Company, GetUser } from 'src/app/auth/auth.interface';
import { FormClientNew } from '../interfaces/profile.interface';
const base_url = environment.base_url;

export interface CertificateDetail {
  owner: string;
  documentNumber: string;
  transmitter: string;
  startDate: string;
  endDate: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private http = inject(HttpClient);
  showModal : boolean = false;
  showModalPass : boolean = false;
  showModalToken : boolean = false;
  showModalLogo  : boolean = false;
  showModalCertificate : boolean = false;
  save$: Subject<boolean> = new Subject();
  editSubs: EventEmitter<GetUser> = new EventEmitter<GetUser>();

  certificate = signal<CertificateDetail | null>(null);
  isLoadingCertificate = signal<boolean>(false);

  constructor() { }

  loadCertificate(company?: Company): void {
    if (company?.modality === 'ELECTRONIC_ONLINE' && company?.uploadCertificate) {
      this.isLoadingCertificate.set(true);
      this.getCertificateDetail().subscribe({
        next: (cert) => {
          this.certificate.set(cert);
          this.isLoadingCertificate.set(false);
        },
        error: () => {
          this.certificate.set(null);
          this.isLoadingCertificate.set(false);
        }
      });
    } else {
      this.certificate.set(null);
      this.isLoadingCertificate.set(false);
    }
  }

  putUpdate(form:FormClientNew) {
    const url = `${base_url}/user/profile`;
    return this.http.put(url, form);
  }

  putChangePassword(form: { currentPassword: string; newPassword: string }) {
    const url = `${base_url}/user/password`;
    return this.http.put(url, form);
  }

  putRefreshToken(form: { siatToken: string; tokenInitDate: Date | string; tokenEndDate: Date | string }) {
    const url = `${base_url}/company/token`;
    return this.http.put(url, form);
  }

  putUploadLogo(image:File) {
    const url = `${base_url}/company/logo`;
    const formData = new FormData();
    formData.append('file', image);
    return this.http.put(url, formData);
  }

  putShowOrHideLogo(showLogo: boolean) {
    const url = `${base_url}/company/showOrHideLogo`;
    return this.http.put(url, { showLogo });
  }

  getCertificateDetail() {
    const url = `${base_url}/certificate`;
    return this.http.get<CertificateDetail>(url);
  }

  postUploadCertificate(file: File, password: string) {
    const url = `${base_url}/certificate`;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('password', password);
    return this.http.post<CertificateDetail>(url, formData);
  }

}
